import { useTranslation } from '@/lib/i18n';
import type { MemberStatus } from '../hooks/useAdminUsersQuery';
import { memberStatusLabel } from '../lib/userLabels';

interface UserStatusBadgeProps {
  status: MemberStatus;
  locked?: boolean;
  /** BUSINESS 면 ACTIVE 를 "승인" 으로 읽는다(memberStatusLabel). */
  memberType?: string | null;
}

export const UserStatusBadge = ({ status, locked = false, memberType }: UserStatusBadgeProps) => {
  const { t } = useTranslation('common');

  const statusStyle: React.CSSProperties = {
    background:
      status === 'ACTIVE'
        ? 'var(--status-success-bg)'
        : status === 'DORMANT'
          ? 'var(--status-warn-bg)'
          : 'var(--surface-1)',
    color:
      status === 'ACTIVE'
        ? 'var(--status-success-fg)'
        : status === 'SUSPENDED'
          ? 'var(--status-danger-fg)'
          : status === 'DORMANT'
            ? 'var(--status-warn-fg)'
            : 'var(--content-muted)',
  };

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className="rounded-full px-2 py-0.5 text-xs font-medium"
        style={statusStyle}
      >
        {memberStatusLabel(t, status, memberType)}
      </span>
      {locked && (
        <span
          className="rounded-full px-1.5 py-0.5 text-[10px] font-semibold"
          style={{ background: 'var(--status-danger-bg)', color: 'var(--status-danger-fg)' }}
        >
          {t('users.locked.badge')}
        </span>
      )}
    </span>
  );
};
